import { useLocation } from 'react-router-dom';
import { ANALYTICS_SCREEN_NAMES } from '../analytics/analyticsEvents';

const extensionPathToScreenNameMap = {
	'/extension': ANALYTICS_SCREEN_NAMES.EXTENSION_HOME_SCREEN,
	'/extension/menu': ANALYTICS_SCREEN_NAMES.EXTENSION_WHATS_NEW_SCREEN,
	'/extension/options': ANALYTICS_SCREEN_NAMES.EXTENSION_OPTIONS_SCREEN,
	'/extension/rovo-chat': ANALYTICS_SCREEN_NAMES.EXTENSION_CHAT_SCREEN,
} as const;

const isValidExtensionPath = (path: string): path is keyof typeof extensionPathToScreenNameMap => {
	return path in extensionPathToScreenNameMap;
};

/**
 * Hook to get the current screen name based on the path
 * @returns The current screen name, or "unknown" if not a valid extension path
 */
export const useCurrentScreenName = (): string => {
	const location = useLocation();
	const normalizedPath = location.pathname.replace(/\/$/, ''); // Remove trailing slash
	return isValidExtensionPath(normalizedPath)
		? extensionPathToScreenNameMap[normalizedPath]
		: 'unknown';
};
